const Element = require('./abstract/element');

module.exports = Text;

function Text () {}
Text.prototype = new Element();
Text.prototype.constructor = Text;

Text.prototype.initialize = function () {
  Element.prototype.initialize.call(this);

  this.structure = _.extend(this.structure, {
    color: null,
    anchor: null,
    content: null,
    decoration: null,
    bullet_points: null,
    auto_adjustable: null,
    direction: null,
    heading: null,
    font: {
      family: null,
      size: null,
      weight: null,
      style: null,
      stretch: null,
      customId: null
    },
    spacing: {
      letter: null,
      word: null,
      line: null,
      margin: null,
      paragraph: null,
      first_line_margin: null,
      right_margin: null
    },
    stroke: {
      width: null,
      color: null,
      dasharray: null
    },
    text: {
      strings: null
    },
    columns: null,
    child_text: null,
    parent_text: null
  });
};

Text.prototype.get = function (element) {
  this.textarea = new INKIVE.Text.Textarea().setDOM(element);
  this.text = this.textarea.text;

  return Element.prototype.get.apply(this, arguments);
};

Text.prototype.getStrokeColor = function () { return this.text.stroke; };
Text.prototype.getStrokeWidth = function () { return this.text.stroke_width; };
Text.prototype.getStrokeDasharray = function () { return this.text.stroke_dasharray; };
Text.prototype.getSpacingParagraph = function () { return this.text.paragraph_spacing; };
Text.prototype.getSpacingFirstLineMargin = function () { return this.text.first_line_margin; };
Text.prototype.getSpacingRightMargin = function () { return this.text.right_margin; };
Text.prototype.getSpacingWord = function () { return this.text.word_spacing; };
Text.prototype.getSpacingLine = function () { return this.text.line_spacing; };
Text.prototype.getSpacingMargin = function () { return this.text.line_margin; };
Text.prototype.getFontFamily = function () { return this.text.font_family; };
Text.prototype.getFontSize = function () { return this.text.font_size; };
Text.prototype.getFontWeight = function () { return this.text.font_weight; };
Text.prototype.getFontStyle = function () { return this.text.font_style; };
Text.prototype.getFontCustomId = function () { return this.text.custom_font_id; };
Text.prototype.getFontStretch = function () { return this.text.font_stretch; };
Text.prototype.getDataParagraphStyle = function () { return this.text.data_paragraph_style; };
Text.prototype.getDataMeta = function () { return this.text.data_meta; };
Text.prototype.getDecoration = function () {
  const underlineStyle = this.text.styles.find(style => style.attribute === 'text-decoration' && style.value === 'underline');
  if (underlineStyle) return 'underline';
  return this.text.text_decoration;
};
Text.prototype.getAnchor = function () { return this.text.text_anchor; };
Text.prototype.getDirection = function () { return this.text.direction; };
Text.prototype.getColor = function () { return this.text.fill; };
Text.prototype.getColumns = function () { return this.text.columns; };
Text.prototype.getBulletPoints = function () { return this.text.bullets; };
Text.prototype.getAutoAdjustable = function () { return this.text.auto_adjustable; };
Text.prototype.getChildText = function () { return this.textarea.child_text; };
Text.prototype.getHeading = function () { return this.textarea.heading || 0; };
Text.prototype.getParentText = function () { return this.textarea.parent_text; };

Text.prototype.getSpacingLetter = function () {
  let letterSpacing = this.text.letter_spacing;

  if (_.isArray(this.text.letter_spacing)) {
    letterSpacing = this.text.letter_spacing.length < 2
      ? 0
      : _.reduce(this.text.letter_spacing, function (memo, num) {
        return memo + parseFloat(num);
      }, 0) / (this.text.letter_spacing.length - 1);
  }

  return letterSpacing;
};

Text.prototype.getContent = function () {
  const conflictSpace = new RegExp(String.fromCharCode(160), 'g');
  return this.text.textContent.replace(conflictSpace, ' ');
};

Text.prototype.getTextStrings = function () {
  const strings = [];
  if (!this.text.strings.length) return null;

  const attributes = ['heading', 'isEol', 'textContent'];
  for (const string of this.text.strings) {
    const property = {};
    for (const key in string) {
      if (attributes.includes(key)) {
        property[key] = string[key];
      }
    }
    strings.push(property);
  }

  return strings;
};
